import licenseApi from '@/api/license.js'

export const setIsAuthenticated = ({ commit }, isAuthenticated) => {
  commit('setIsAuthenticated', isAuthenticated)
}

export const setCurrentUser = ({ commit }, user) => {
  commit('setCurrentUser', user)
}

export const setHasPaidLicense = ({ commit }, group_id) => {
  return licenseApi.getUserLicense(group_id).then(license => {
    commit('setHasPaidLicense', license)
  })
}

export const setLicenseFromPublish = ({ commit }, license) => {
  commit('setHasPaidLicense', license)
}

export const setLocale = ({ commit }, locale) => {
  commit('setLocale', locale)
}
